import $ from 'jquery';

const IconToggle = () => {
  $(document).on('click', '[data-icon-toggle]', (e) => {
    $(e.currentTarget).toggleClass('IconToggle--open');
  });
};

export {
  IconToggle,
};